import React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';
import Page from 'components/page/Page';
import SVGIcon from 'components/svg-icon/SVGIcon';
import AccessContainer from '../components/access-container/AccessContainer';
import { t } from 'utils/language';
import { LocationWindow } from 'types';

import '../common/access-actions.scss';

type Props = {
  location: LocationWindow
};

const NewPasswordNotificationPage = ({ location }: Props) => {
  const action = location.query.action || 'reset';

  return (
    <Page
      documentTitle={t('new_password_notification_page_title')}
    >
      <AccessContainer type="signup-success">
        <p className="access-container__icon">
          <SVGIcon
            name="lock-dark"
            width={240}
            height={160}
          />
        </p>
        <p className="access-container__description">
          {t(action === 'create' ?
            'signup_created_password_confirmation' :
            'password_reset_success'
          )}
        </p>
        <div className="access-actions access-actions--center">
          <ActionButton link="/login">
            {t(action === 'create' ?
              'signup_get_started_button' :
              'login'
            )}
          </ActionButton>
        </div>
      </AccessContainer>
    </Page>
  );
};

export default NewPasswordNotificationPage;
